import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '';
  const navLinks = [{
    name: 'Results',
    href: isHomePage ? '#results' : '/results'
  }, {
    name: 'What You Get',
    href: isHomePage ? '#included' : '/included'
  }, {
    name: 'Demos',
    href: isHomePage ? '#demos' : '/demos'
  }, {
    name: 'Pricing',
    href: isHomePage ? '#pricing' : '/pricing'
  }, {
    name: 'FAQ',
    href: isHomePage ? '#faq' : '/faq'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      // Anchor scroll on home page — default behavior
      return;
    }
    // Route navigation
    e.preventDefault();
    window.history.pushState({}, '', href);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
  };
  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.history.pushState({}, '', '/');
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
  };
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'backdrop-blur-md border-b border-[#c9a84c]/20 py-3' : 'py-5'}`} style={{
    backgroundColor: isScrolled ? 'rgba(5, 5, 5, 0.92)' : 'transparent'
  }} data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-189">
        <a href="/" onClick={handleLogoClick} className="text-2xl font-bold tracking-tight" style={{
        fontFamily: "'Space Grotesk', sans-serif"
      }} data-id="element-190">
          <span className="text-white" data-id="element-191">ai</span>
          <span className="text-[#c9a84c]" data-id="element-192">.</span>
          <span className="text-white" data-id="element-193">web</span>
        </a>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-194">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-sm text-white/80 hover:text-[#c9a84c] transition-colors" data-id="element-195">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden md:flex items-center space-x-4" data-id="element-196">
          <div className="px-3 py-1 rounded-full border border-[#c9a84c]/50 bg-[#c9a84c]/10" data-id="element-197">
            <span className="text-xs font-medium text-[#c9a84c]" data-id="element-198">
              Dublin Offer • €249
            </span>
          </div>
          <a href={isHomePage ? '#contact' : '/contact'} onClick={e => handleNavClick(e, isHomePage ? '#contact' : '/contact')} className="px-5 py-2 border border-[#c9a84c] text-[#c9a84c] rounded-md hover:bg-[#c9a84c] hover:text-black transition-all duration-300 text-sm font-medium" data-id="element-199">
            Contact
          </a>
        </div>

        <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-200">
          {isMobileMenuOpen ? <X data-id="element-201" /> : <Menu data-id="element-202" />}
        </button>
      </div>

      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 border-b border-white/10 p-4 flex flex-col space-y-4 shadow-2xl" style={{
      backgroundColor: '#0a0a0a'
    }} data-id="element-203">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/80 hover:text-[#c9a84c] py-2 block" onClick={e => {
        handleNavClick(e, link.href);
        setIsMobileMenuOpen(false);
      }} data-id="element-204">
              {link.name}
            </a>)}
          <div className="pt-4 border-t border-white/10 flex flex-col space-y-4" data-id="element-205">
            <span className="text-center text-xs font-medium text-[#c9a84c] border border-[#c9a84c]/30 rounded-full py-1" data-id="element-206">
              Dublin Offer • €249
            </span>
            <a href={isHomePage ? '#contact' : '/contact'} className="w-full text-center px-5 py-3 bg-[#c9a84c] text-black rounded-md font-medium" onClick={e => {
          handleNavClick(e, isHomePage ? '#contact' : '/contact');
          setIsMobileMenuOpen(false);
        }} data-id="element-207">
              Contact Us
            </a>
          </div>
        </div>}
    </header>;
}